<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.BookingAudit')"
    :width="$selectByLang('620px', '660px')"
    custom-class="cargo-form-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="form" :label-width="$selectByLang('100px', '120px')" label-position="left" class="cargo-form">
      <el-row v-if="isDifferentJobOrBusinessFieldValues" :gutter="10">
        <el-col :span="24">
          <el-form-item label-width="0" class="auto-width">
            <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
            <span style="font-size: 12px;">{{ $t('Message.DifferentJobOrBusinessFieldValues') }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.OperationCompany')+'：'" class="required">
            <cargo-office-select
              :clearable="false"
              :have-hq="false"
              :office-id="Number(job.opOffice)"
              tag-name="code"
              tooltip
              @change="p=>{job.opOffice=p.value;officeChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Operation')+'：'">
            <cargo-user-select
              :method-params="{officeId: job.opOffice,category:'role',shape:'op'}"
              :default-value="job.op||''"
              :placeholder="differentForm.op ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.Operation')"
              @change="p=>{job.op=p.value;differentForm.op=true;opChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.OperationDepartment')+'：'" :class="isBatchUpdate ? '' : 'required'">
            <cargo-department-select
              :office-id="Number(job.opOffice) || $store.getters.currentOfficeId"
              :department-id="Number(job.opDepartment)"
              :placeholder="differentForm.opDepartment ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.OperationDepartment')"
              @change="p=>{job.opDepartment=p.value;differentForm.opDepartment=true;}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerService')+'：'">
            <cargo-user-select
              ref="csr"
              :method-params="{officeId:(job.salesOffice === 1 ? job.opOffice : job.salesOffice),category:'role',shape:'csr'}"
              :default-value="job.csr||''"
              :placeholder="differentForm.csr ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.CustomerService')"
              @change="p=>{job.csr=p.value;differentForm.csr=true;csrChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Documents')+'：'">
            <cargo-user-select
              ref="dc"
              :method-params="{officeId: job.opOffice, category:'role',shape:'doc'}"
              :default-value="job.dc||''"
              :placeholder="differentForm.dc ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.Documents')"
              @change="p=>{job.dc=p.value;differentForm.dc=true;dcChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.BookingAgent')+'：'">
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              :method-params="{bookingAgent:true,companyLob:'airExport',active:true}"
              :default-value="job.bookingAgent||''"
              :placeholder="differentForm.bookingAgent ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('SeaExport.BookingAgent')"
              @parentCallBack="p=>{job.bookingAgent=p.value;differentForm.bookingAgent=true;}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')+'：'">
            <cargo-user-select
              ref="userDefinedRoleId1"
              no="24"
              :method-params="{officeId:job.opOffice,category:'role',shape:'userDefinedRole1'}"
              :default-value="job.userDefinedRoleId1||''"
              :placeholder="differentForm.userDefinedRoleId1 ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('CargoMsg.Cargo_userDefinedRole1')"
              @change="p=>{job.userDefinedRoleId1=p.value;differentForm.userDefinedRoleId1=true;userDefinedRole1ChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')+'：'">
            <cargo-user-select
              ref="userDefinedRoleId2"
              no="25"
              :method-params="{officeId:job.opOffice,category:'role',shape:'userDefinedRole2'}"
              :default-value="job.userDefinedRoleId2||''"
              :placeholder="differentForm.userDefinedRoleId2 ? $t('CargoMsg.Cargo_keyWordsTip') : $t('Message.PreserveOriginalValue') + $t('CargoMsg.Cargo_userDefinedRole2')"
              @change="p=>{job.userDefinedRoleId2=p.value;differentForm.userDefinedRoleId2=true;userDefinedRole2ChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')+'：'">
            <el-input v-model="bookingAuditRemark" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import CargoForm from '@/components/Cargo/Common/CargoForm/index.vue'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getUserInfo } from '@/utils/auth'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getIeJobByUuidFunc } from '@/api/integratedJob/ieBooking'

export default {
  name: 'AcceptDialog',
  components: { cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect, cargoCompanySelect, cargoAdvanceSelect, CargoForm },
  props: {
    visible: { type: Boolean, default: () => false },
    jobModel: { type: Object, default: () => ({}) },
    submitCallBack: { type: Function, default: () => (null) },
    jobList: { type: Array, default: () => ([]) }
  },
  data() {
    return {
      job: {
        uuid: '',
        version: 0, // 版本号，用于后台校验是否发生变更
        opOffice: 0, // 操作分公司
        op: 0, // 操作
        opDepartment: 0, // 操作部门
        csr: 0, // 客户
        csrDepartment: 0, // 客服部门
        csrOffice: 0, // 客户分公司
        bookingAgent: 0, // 订舱代理
        dc: 0, // 单证
        dcDepartment: 0, // 单证部门
        dcrOffice: 0, // 单证分公司
        remarks: '', // 备注
        userDefinedRoleId1: '', // 自定义岗位1
        userDefinedRoleId2: '' // 自定义岗位2
      },
      officeId: 0,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      currentUserInfo: {},
      bookingAuditRemark: '',
      differentForm: {
        op: true,
        opDepartment: true,
        csr: true,
        dc: true,
        userDefinedRoleId1: true,
        userDefinedRoleId2: true,
        bookingAgent: true
      },
      isDifferentJobOrBusinessFieldValues: false
    }
  },
  computed: {
    isBatchUpdate() { // 是否批量修改
      return this.jobList && this.jobList.length > 1
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          await this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isAddUserDefinedRoles = Number(cache.config.get('IsAddUserDefinedRoles')) === 1
  },
  methods: {
    async init() {
      this.currentUserInfo = getUserInfo()
      const dbJob = await getIeJobByUuidFunc(this.jobModel.uuid).then((res) =>
        res.data ? res.data : null
      )
      if (dbJob) Object.assign(this.job, dbJob)
      // 处理审核备注显示 备注内容单条带出信息，多条则不显示==》 特殊情况，jobList长度有值说明是列表勾选，没有值说明是详情
      if (this.jobList.length === 1 || this.jobList.length === 0) {
        this.bookingAuditRemark = this.job.remarks
      }
      this.isDifferentJobOrBusinessFieldValues = JobUtils.verifyCheckJobFieldDifferent(this.job, this.jobList, this.differentForm, SystemConstants.IE.code)
    },
    // 切换分公司
    officeChangeHandler() {
      if (!this.job.opOffice || this.job.opOffice <= 0) {
        this.job.opOffice = this.$store.getters.currentOfficeId
      }
    },
    // 单证改变
    async dcChangeHandler(data) {
      this.job.dc = data.value || 0
      this.job.dcDepartment = 0
      this.job.dcOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        this.job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.dcOffice = office ? office.officeId : 0
      }
    },
    // 操作改变
    async opChangeHandler(data) {
      this.job.op = data.value
      this.job.opDepartment = 0
      if (data.value > 0) {
        const user = new User(data)
        const dep = await user.getUserDefaultDepartmentByOffice('role', 'op', this.job.opOffice)
        this.job.opDepartment = dep ? dep.departmentId : 0
      }
    },
    // 客服改变
    async csrChangeHandler(data) {
      this.job.csr = data.value
      this.job.csrDepartment = 0
      this.job.csrOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          this.job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          this.job.csrOffice = office ? office.officeId : 0
        }
      }
    },
    handleSubmit() {
      if (!this.job.opOffice || this.job.opOffice <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationCompanyCannotBeEmpty'))
        return
      }
      if (!this.isBatchUpdate) {
        if (!this.job.opDepartment || this.job.opDepartment <= 0) {
          this.$message.warning(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'))
          return
        }
      }
      const form = {}
      form.uuid = this.job.uuid
      form.version = this.job.version
      form.opOffice = this.job.opOffice || 0
      form.op = this.job.op || 0
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        form.opDepartment = this.job.opDepartment || 0
      }
      form.csr = this.job.csr || 0
      if (!form.csr) {
        form.csrDepartment = 0
        form.csrOffice = 0
      } else {
        form.csrDepartment = this.job.csrDepartment || 0
        form.csrOffice = this.job.csrOffice || 0
      }
      form.dc = this.job.dc || 0
      if (!form.dc) {
        form.dcDepartment = 0
        form.dcOffice = 0
      } else {
        form.dcDepartment = this.job.dcDepartment || 0
        form.dcOffice = this.job.dcOffice || 0
      }
      form.bookingAgent = this.job.bookingAgent || 0
      form.userDefinedRoleId1 = this.job.userDefinedRoleId1 || 0
      if (!form.userDefinedRoleId1) {
        form.userDefinedRoleDept1 = 0
        form.userDefinedRoleOffice1 = 0
      } else {
        form.userDefinedRoleDept1 = this.job.userDefinedRoleDept1
        form.userDefinedRoleOffice1 = this.job.userDefinedRoleOffice1
      }
      form.userDefinedRoleOffice2 = this.job.userDefinedRoleOffice2 || 0
      form.userDefinedRoleId2 = this.job.userDefinedRoleId2 || 0
      if (!form.userDefinedRoleId2) {
        form.userDefinedRoleDept2 = 0
        form.userDefinedRoleOffice2 = 0
      } else {
        form.userDefinedRoleDept2 = this.job.userDefinedRoleDept2
        form.userDefinedRoleOffice2 = this.job.userDefinedRoleOffice2
      }
      form.bookingTerm = this.job.bookingTerm
      form.bookingAuditRemark = this.bookingAuditRemark
      form.differentForm = this.differentForm
      this.submitCallBack(form)
      this.handleClose()
    },
    handleClose() {
      this.innerVisible = false
    },
    // 自定义岗位1
    async userDefinedRole1ChangeHandler(data) {
      this.job.userDefinedRoleId1 = data.value
      this.job.userDefinedRoleDept1 = 0
      this.job.userDefinedRoleOffice1 = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        this.job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.userDefinedRoleOffice1 = office ? office.officeId : 0
      } else {
        this.job.userDefinedRoleId1 = 0
        this.job.userDefinedRoleDept1 = 0
        this.job.userDefinedRoleOffice1 = 0
      }
    },
    // 自定义岗位2
    async userDefinedRole2ChangeHandler(data) {
      this.job.userDefinedRoleId2 = data.value
      this.job.userDefinedRoleDept2 = 0
      this.job.userDefinedRoleOffice2 = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        this.job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        this.job.userDefinedRoleOffice2 = office ? office.officeId : 0
      } else {
        this.job.userDefinedRoleId2 = 0
        this.job.userDefinedRoleDept2 = 0
        this.job.userDefinedRoleOffice2 = 0
      }
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .required .el-form-item__label {
    color: #1F75D5!important
  }
  .cargo-form{
    .el-form-item {
      &.red-input{
        .el-input__inner{
          color: #E9650E;
        }
      }
      &__content{
        width: auto!important;
      }
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
